<script setup>
import { Facebook, Instagram, Linkedin } from 'lucide-vue-next';

const socials = [
  { name: 'LinkedIn', href: 'https://www.linkedin.com/company/spotsurfer', icon: Linkedin },
  { name: 'Instagram', href: 'https://www.instagram.com/spotsurferofficial/', icon: Instagram },
  { name: 'Facebook', href: 'https://www.facebook.com/p/Spotsurfer-100088235870371/', icon: Facebook },
];

const footerLinks = [
  {
    title: 'Company',
    links: [
      { name: 'About Us', href: '/about' },
      { name: 'News', href: '/news-happenings' },
      { name: 'Investors', href: '/investors' },
      { name: 'Community Hub', href: '/community' },
    ],
  },
  {
    title: 'Support',
    links: [
      { name: 'Contact Us', href: '/contact-us' },
      { name: 'Help Center', href: '/faqs' },
      { name: 'Account Deletion', href: '/account-deletion-request' },
      { name: 'Terms & Conditions', href: '/terms-and-conditions' },
    ],
  },
];
</script>

<template>
  <footer class="w-full border-t border-white/10 bg-slate-950 text-white">
    <div class="mx-auto flex max-w-4xl flex-col items-center gap-6 px-4 pb-20 pt-10 text-center sm:pb-8">
      <NuxtLink to="/" class="flex flex-col items-center gap-2">
        <img class="h-12 w-12" src="/images/spotsurferLogo.png" alt="" loading="lazy">
        <span class="text-lg font-semibold leading-tight tracking-tight">Spotsurfer</span>
        <span class="mt-2 text-2xl uppercase tracking-[0.3em] text-white md:text-3xl">Reserve. Park. Play.</span>
      </NuxtLink>
      <a href="https://apps.apple.com/us/app/spotsurfer/id6639622146" target="_blank" rel="noopener">
        <img class="h-10" src="/images/apple_app_store.svg" alt="Download on the App Store" loading="lazy" />
      </a>
      <nav class="flex max-w-md flex-wrap justify-center gap-x-5 gap-y-2 sm:max-w-none" aria-label="Footer">
        <template v-for="section in footerLinks" :key="section.title">
          <NuxtLink v-for="link in section.links" :key="link.name" class="text-sm text-slate-300 transition-colors hover:text-white" :to="link.href">{{ link.name }}</NuxtLink>
        </template>
      </nav>
      <div class="flex gap-2">
        <a
          v-for="s in socials"
          :key="s.name"
          :href="s.href"
          :aria-label="s.name"
          target="_blank"
          rel="noopener"
          class="rounded-full border border-white/10 bg-white/5 p-2 text-slate-300 transition hover:border-accent-orange/40 hover:bg-accent-orange/10 hover:text-accent-orange"
        >
          <component :is="s.icon" class="h-4 w-4 stroke-[1.5]" />
        </a>
      </div>
      <p class="text-xs text-slate-500">© 2024 - {{ new Date().getFullYear() }} Hohenco Technologies LLC. All rights reserved.</p>
    </div>
  </footer>
</template>
